// @deprecated cf. settings module
export const settingsStateSelector = (state) => state.settings;
export const settingsSelector = (state) => state.settings.settings;
